export default __webpack_public_path__ + "f752707ec34c2fde2bcbf901a46bc7e4.png";